import React from 'react';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from '@react-navigation/native-stack';
import {useTheme} from 'contexts/ThemeContext';
import {Flows, Screens} from './Screens';

const Stack = createNativeStackNavigator();

export interface LoginScreenProps {
  navigation: NativeStackNavigationProp<{[Flows.tabBarFlow]: undefined}>;
}

const AuthFlow = () => {
  const theme = useTheme();

  return (
    <Stack.Navigator>
      <Stack.Screen
        name={Screens.LoginScreen.name}
        component={Screens.LoginScreen.screen}
        options={{headerShown: false}}
      />
    </Stack.Navigator>
  );
};

export default AuthFlow;
